import {getLocalizationService} from '~/shared/services/localisationService';

// Api value expected fro Free Fit vendor
const FREE_FIT_VENDOR_NAME = 'FREEFIT';

export const getIsFreeFitVendor = (vendor?: string) => {
  return vendor === FREE_FIT_VENDOR_NAME;
};

export const getVendorDisclaimer = (vendor?: string, isGovCompany?: boolean) => {
  const {t} = getLocalizationService();

  return (getIsFreeFitVendor(vendor) ?
    t('freefit_voucher_disclaimer') :
    `${t('list_of_chains_is_listed')} ${isGovCompany ? t('in_accordance_with') : ''} ${t('this_order_can_not_be_canceled')}`
  );
};
